import { render } from "./Root.vue?vue&type=template&id=ef5ae90e"
import script from "./Root.vue?vue&type=script&lang=js"
export * from "./Root.vue?vue&type=script&lang=js"

import "./Root.vue?vue&type=style&index=0&id=ef5ae90e&lang=postcss"
script.render = render

export default script